import { useState, useEffect, useRef } from 'react';

/**
 * Hook to manage entrance animations when game starts
 * Returns animation state and triggers animations on game load
 */
export const useGameStartAnimations = (gameState) => {
  const [animationsStarted, setAnimationsStarted] = useState(false);
  const hasAnimatedRef = useRef(false);

  useEffect(() => {
    // Start animations when gameState is first loaded (only once)
    if (gameState && !hasAnimatedRef.current) {
      hasAnimatedRef.current = true;
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        setAnimationsStarted(true);
      }, 100);
    }
  }, [gameState]);

  return { animationsStarted };
};

/**
 * Get CSS animation styles for slide-in animations
 */
export const getSlideInStyles = (animationsStarted, direction = 'left', delay = 0) => {
  const getInitialTransform = () => {
    switch (direction) {
      case 'left':
        return 'translateX(-100vw)';
      case 'right':
        return 'translateX(100vw)';
      case 'top':
        return 'translateY(-100vh)';
      case 'bottom':
        return 'translateY(100vh)';
      default:
        return 'translateX(-100vw)';
    }
  };

  return {
    transition: `transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.8s ease-in-out`,
    transform: animationsStarted ? 'translate(0, 0)' : getInitialTransform(),
    opacity: animationsStarted ? 1 : 0,
    transitionDelay: `${delay}ms`,
  };
};

